import * as actionTypes from './constants'
import { api } from 'app/modules/sfdc/api'

export function fetchSFDCPropertiesSuccess({ properties }) {
  return {
    type: actionTypes.FETCH_SFDC_ATTRIBUTES_SUCCESS,
    properties
  }
}

export function fetchSFDCMappingsSuccess({ mappings, useCountryAcronyms, useStateAcronyms, allowAttributeDefaults, createContactOnCaseCreation }) {
  return {
    type: actionTypes.FETCH_SFDC_MAPPINGS_SUCCESS,
    mappings: convertMappingFromSfdcToIntegration(mappings),
    useCountryAcronyms, useStateAcronyms, allowAttributeDefaults, createContactOnCaseCreation
  }
}

export function fetchSFDCMappingsFailed(err) {
  return {
    type: actionTypes.FETCH_SFDC_MAPPINGS_ERROR,
    err
  }
}

export function fetchSFDCMetricsMappingsSuccess({ mappings }) {
  return {
    type: actionTypes.FETCH_SFDC_METRIC_MAPPINGS_SUCCESS,
    mappings
  }
}

export function fetchSFDCMetricsMappingsFailed(err) {
  return {
    type: actionTypes.FETCH_SFDC_METRIC_MAPPINGS_ERROR,
    err
  }
}

export function fetchMetricsListSuccess({ list }) {
  return {
    type: actionTypes.FETCH_METRICS_LIST_SUCCESS,
    list
  }
}

export function fetchMetricsListFailed(err) {
  return {
    type: actionTypes.FETCH_METRICS_LIST_ERROR,
    err
  }
}

export function fetchSFDCPropertiesFailed(err) {
  return {
    type: actionTypes.FETCH_SFDC_ATTRIBUTES_ERROR,
    err
  }
}

export function patchSFDCMappingsSuccess({ mappings }) {
  return {
    type: actionTypes.PATCH_SFDC_MAPPINGS_SUCCESS,
    mappings: convertMappingFromSfdcToIntegration(mappings)
  }
}

export function patchSFDCMappingsError(err) {
  return {
    type: actionTypes.PATCH_SFDC_MAPPINGS_ERROR,
    err
  }
}

export function patchSFDCMappingsStart() {
  return {
    type: actionTypes.PATCH_SFDC_MAPPINGS_START
  }
}

export function patchSFDCMetricsMappingsSuccess({ mappings }) {
  return {
    type: actionTypes.PATCH_SFDC_METRIC_MAPPINGS_SUCCESS,
    mappings
  }
}

export function patchSFDCMetricsMappingsError(err) {
  return {
    type: actionTypes.PATCH_SFDC_METRIC_MAPPINGS_ERROR,
    err
  }
}

export function patchSFDCMetricMappingsStart() {
  return {
    type: actionTypes.PATCH_SFDC_METRIC_MAPPINGS_START
  }
}

export function fetchSFDCProperties(propertyType) {
  return (dispatch) => {
    api.fetchSFDCProperties(propertyType).then(response => {
      dispatch(fetchSFDCPropertiesSuccess(response))
    }).catch(
      err => dispatch(fetchSFDCPropertiesFailed(err))
    )
  }
}

export function fetchSFDCMappings() {
  return dispatch => { 
    api.fetchSFDCMappings().then(response => {
      dispatch(fetchSFDCMappingsSuccess(response))
    }).catch(err => dispatch(fetchSFDCMappingsFailed(err)))
  }
}

export function fetchSFDCMetricsMappings() {
  return dispatch => { 
    api.fetchSFDCMetricsMappings().then(response => {
      dispatch(fetchSFDCMetricsMappingsSuccess(response))
    }).catch(err => dispatch(fetchSFDCMetricsMappingsFailed(err)))
  }
}

export function fetchMetricsList() {
  return dispatch => { 
    api.fetchMetricsList().then(response => {
      dispatch(fetchMetricsListSuccess({ "list": response }))
    }).catch(err => dispatch(fetchMetricsListFailed(err)))
  }
}

export function patchSFDCMappings(mappings, useRawMapping, successCB = () => {}) {
  return dispatch => { 
    dispatch(patchSFDCMappingsStart())
    api.patchSFDCMappings(mappings, useRawMapping)
      .then(response => {
        successCB()
        dispatch(patchSFDCMappingsSuccess(response))
      })
      .catch(err => {
        dispatch(patchSFDCMappingsError(err))
      })
  }
}

export function patchSFDCMetricsMappings(mappings, successCB = () => {}) {
  return dispatch => { 
    dispatch(patchSFDCMetricMappingsStart())
    api.patchSFDCMetricsMappings(mappings)
      .then(response => {
        dispatch(patchSFDCMetricsMappingsSuccess(response))
        successCB()
      })
      .catch(err => {
        dispatch(patchSFDCMetricsMappingsError(err))
      })
  }
}

export function searchSFDCUsersSuccess({ users }) {
  return {
    type: actionTypes.FETCH_SFDC_USERS_SUCCESS,
    users
  }
}

export function searchSFDCUsersError() {
  return {
    type: actionTypes.FETCH_SFDC_USERS_ERROR,
  }
}

export function searchSFDCUsersStart() {
  return {
    type: actionTypes.FETCH_SFDC_USERS_START,
  }
}

export function searchSFDCUsers(query) {
  return dispatch => { 
    dispatch(searchSFDCUsersStart())
    api.searchSFDCUsers(query).then(response => {
      dispatch(searchSFDCUsersSuccess(response))
    })
  }
}

export function fetchSFDCUserMappingsSuccess({ mappings, users }) {
  return {
    type: actionTypes.FETCH_SFDC_USER_MAPPINGS_SUCCESS,
    mappings,
    users
  }
}

export function fetchSFDCUserMappings() {
  return dispatch => { 
    api.fetchSFDCUserMappings().then(response => {
      dispatch(fetchSFDCUserMappingsSuccess(response))
    })
  }
}

export function patchSFDCUserMappings(data) {
  return dispatch => { 
    api.patchSFDCUserMappings(data)
      .then(resp => {
        dispatch(patchSFDCUserMappingsSuccess(resp))
      })
      .catch(err => {
        dispatch(patchSFDCUserMappingsFailed(err))
      })
  }
}

export function patchSFDCUserMappingsFailed(err) {
  return {
    type: actionTypes.PATCH_SFDC_USER_MAPPINGS_FAILED,
    err
  }
}

export function patchSFDCUserMappingsSuccess({ mappings }) {
  return {
    type: actionTypes.FETCH_SFDC_USER_MAPPINGS_SUCCESS,
    mappings
  }
}

export function fetchSFDCObjectList() {
  return dispatch => {
    api.getSalesforceObjectList().then(response => {
      dispatch(fetchSFDCObjectListSuccess(response))
    }).catch(
      err => dispatch(fetchSFDCObjectListError(err))
    )
  }
}

export function fetchSFDCObjectListSuccess({ objects }) {
  return {
    type: actionTypes.FETCH_SFDC_OBJECT_LIST_SUCCESS,
    objects
  }
}

export function fetchSFDCObjectListError(err) {
  return {
    type: actionTypes.FETCH_SFDC_OBJECT_LIST_ERROR,
    err
  }
}

export function fetchSFDCFieldList(fieldType) {
  return (dispatch) => {
    api.getSalesforceFieldList(fieldType).then(response => {
      dispatch(fetchSFDCFieldListSuccess(fieldType, response.fields))
    }).catch(
      err => dispatch(fetchSFDCFieldListError(fieldType, err))
    )
  }
}

export function fetchSFDCFieldListSuccess(fieldType, fields) {
  return {
    type: actionTypes.FETCH_SFDC_FIELD_LIST_SUCCESS,
    fieldType,
    fields
  }
}

export function fetchSFDCFieldListError(fieldType, err) {
  return {
    type: actionTypes.FETCH_SFDC_FIELD_LIST_ERROR,
    fieldType,
    err
  }
}

export function fetchSFDCFLeadRoutingSettings() {
  return (dispatch) => {
    api.getSalesforceLeadRoutingSettings().then(response => {
      dispatch(fetchSFDCLeadRoutingSettingsSuccess(response))
    }).catch(
      err => dispatch(fetchSFDCLeadRoutingSettingsError(err))
    )
  }
}

export function fetchSFDCLeadRoutingSettingsSuccess({ settings }) {
  return {
    type: actionTypes.FETCH_SFDC_LEAD_ROUTING_SETTINGS_SUCCESS,
    settings
  }
}

export function fetchSFDCLeadRoutingSettingsError(err) {
  return {
    type: actionTypes.FETCH_SFDC_LEAD_ROUTING_SETTINGS_ERROR,
    err
  }
}

export function fetchSalesforceEnrichmentByEmail({ email, domain }) {
  return dispatch => {
    if (email) {
      dispatch(fetchSalesforceEnrichmentStart(email))
      api.fetchSalesforceEnrichmentByEmail({ email }).then(response => {
        dispatch(fetchSalesforceEnrichmentSuccess(response, email))
      }).catch(
        err => err.status === 404 && !!domain ? fetchSalesforceEnrichmentByDomain(dispatch, email, { domain }) : dispatch(fetchSalesforceEnrichmentFailed(err, email))
      )
    } else if (domain) {
      fetchSalesforceEnrichmentByDomain(dispatch, email, { domain })
    } else {
      dispatch(fetchSalesforceEnrichmentFailed({ status: 404 }, email))
    }
  }
}

export function fetchSalesforceEnrichmentByDomain(dispatch, key, { domain }) {
  dispatch(fetchSalesforceEnrichmentStart(key))
  api.fetchSalesforceEnrichmentByDomain({ domain }).then(response => {
    dispatch(fetchSalesforceEnrichmentSuccess(response, key))
  }).catch(
    err => dispatch(fetchSalesforceEnrichmentFailed(err, key))
  )
}

export function fetchSalesforceEnrichmentStart(key) {
  return {
    type: actionTypes.FETCH_SALESFORCE_ENRICHMENT_STARTED,
    key
  }
}

export function fetchSalesforceEnrichmentFailed(err, key) {
  return {
    type: actionTypes.FETCH_SALESFORCE_ENRICHMENT_FAILED,
    err,
    key
  }
}

export function fetchSalesforceEnrichmentSuccess(data, key) {
  return {
    type: actionTypes.FETCH_SALESFORCE_ENRICHMENT_SUCCESS,
    data,
    key
  }
}

export function fetchSFDCEnrichmentFields() {
  return (dispatch) => {
    api.fetchSalesforceEnrichmentFields().then(response => {
      dispatch(fetchSFDCEnrichmentFieldsSuccess(response))
    }).catch(
      err => dispatch(fetchSFDCEnrichmentFieldsError(err))
    )
  }
}

export function patchSFDCEnrichmentFields({ fields }) {
  return (dispatch) => {
    api.patchSalesforceEnrichmentFields({ fields }).then(response => {
      dispatch(patchSFDCEnrichmentFieldsSuccess(response))
    }).catch(
      err => dispatch(patchSFDCEnrichmentFieldsError(err))
    )
  }
}

export function fetchSFDCEnrichmentFieldsSuccess(fields) {
  return {
    type: actionTypes.FETCH_SFDC_ENRICHMENT_FIELDS_SUCCESS,
    fields
  }
}

export function fetchSFDCEnrichmentFieldsError(err) {
  return {
    type: actionTypes.FETCH_SFDC_ENRICHMENT_FIELDS_ERROR,
    err
  }
}

export function patchSFDCEnrichmentFieldsSuccess(fields) {
  return {
    type: actionTypes.PATCH_SFDC_ENRICHMENT_FIELDS_SUCCESS,
    fields
  }
}

export function patchSFDCEnrichmentFieldsError(err) {
  return {
    type: actionTypes.PATCH_SFDC_ENRICHMENT_FIELDS_ERROR,
    err
  }
}
function convertMappingFromSfdcToIntegration(mappings) {
  return mappings.map(entry => {
    const {defaultValue, driftAttribute, isOverwritable, salesforceAttribute} = entry
    return {
      defaultValue,
      driftAttribute,
      isOverwritable,
      integrationAttribute: salesforceAttribute,
      editable: !entry["static"]
    }
  })
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/sfdc/actions.js